module.exports = __webpack_public_path__ + "static/media/background_6.9b63229d.png";